import { Box, Skeleton, Stack } from "@mui/material";

/** Placeholder that mirrors EditFamilyModal's body while Q1 is loading. */
const EditFamilyModalSkeleton = () => {
  return (
    <>
      <Box sx={{ mt: 2 }}>
        <Skeleton width={90} height={16} sx={{ mb: 0.5 }} />
        <Skeleton variant="rounded" height={40} />
      </Box>

      <Box sx={{ mt: 2 }}>
        <Skeleton width={70} height={16} sx={{ mb: 0.5 }} />
        <Skeleton variant="rounded" height={40} />
      </Box>

      <Box sx={{ mt: 2 }}>
        <Skeleton width={100} height={20} sx={{ mb: 1 }} />
        <Stack spacing={1}>
          <Skeleton variant="rounded" height={56} />
          <Skeleton variant="rounded" height={56} />
        </Stack>
      </Box>

      <Box sx={{ mt: 2 }}>
        <Skeleton width={90} height={20} sx={{ mb: 1 }} />
        <Skeleton variant="rounded" height={40} />
      </Box>
    </>
  );
};

export default EditFamilyModalSkeleton;
